import { useState, useEffect } from 'react'
import { getAllFaqs, deleteFAQWithId, editFaq } from './../../../../../api'
function Faqs({ openForm }){
  // console.log(data);
  const [allFaqData, setAllFaqData] = useState([])
  useEffect(async () => {
    const response = await getAllFaqs();
    setAllFaqData(response.data.allFaqs)
  },[])

  const handleDelete = async (event, faqId) => {
    event.preventDefault()
    event.target.disabled = true

    const { data } = await deleteFAQWithId(faqId)
    if (data.success && allFaqData) {
      const newFaqData = allFaqData.filter(FAQ => FAQ._id !== data.faq._id)
      setAllFaqData(newFaqData)
      event.target.disabled = false
    } else {
      // Send Error Message
      event.target.disabled = false
    }

  }

  const handleEdit = async (faqId, faqData) => {
    // const { data } = await editJob(jobId, jobData)
    // console.log("Edited Data:", data)
    faqData._id = faqId
    openForm({ faqData })
  }

  return(
    <>
    <h2>Faq's</h2>
    <div className="table__container">
      <table className="table">
        <tr  className="table__header">
          <th>Question</th>
          <th>Answer</th>
          <th>edit</th>
          <th>delete</th>
        </tr>
        {allFaqData ? allFaqData.map((data, index)=>(
          <tr className="table__row" key={index}>
            <td  className="width-min">{data.ques}</td>
            <td  className="width-min">{data.ans}</td>
            <td><button onClick={(e) => handleEdit(data._id, data)}>edit</button></td>
            <td><button onClick={(e) => handleDelete(e, data._id)}>delete</button></td>
          </tr>
        )): <></>}
        {/* <tr className="table__row">
          <td>john doe</td>
          <td>XYZ company</td>
        </tr>
        <tr className="table__row">
          <td>john doe</td>
          <td>XYZ company</td>
        </tr> */}
      </table>
    </div>
    </>
  )
}

export default Faqs
